<template>
  <div class="app flex-row align-items-center">
    <b-alert v-model="failedLogin" variant="danger" class="error-container"  dismissible>
      <span class="fa fa-exclamation-circle"></span>
      <strong> Login Failed. </strong> Please check your credentials and try again.
    </b-alert>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @keypress.enter="doLogin">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" v-model="user" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="doLogin()">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Coming Soon!</p>
                  <b-button variant="primary" class="active mt-3" @click="myModal=true">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <b-modal title="Create New Account" large v-model="myModal" @ok="saveAccount" effect="fade/zoom" ok-text="Sign-up" cancel-text="Cancel">
    <div class="col-sm-12">
          <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
            <div class="form-group">
              <!--<label for="title">First Name</label>-->
              <input type="text" class="form-control" id="firstname" placeholder="First Name" v-model="formData.firstName" required>
            </div>
            <div class="form-group">
              <!--<label for="title">Last Name</label>-->
              <input type="text" class="form-control" id="lastname" placeholder="Last Name" v-model="formData.lastName">
            </div>
            <div class="form-group">
              <!--<label for="title">Last Name</label>-->
              <input type="email" class="form-control" id="email" placeholder="Email Address" v-model="formData.email">
            </div>
            <div class="form-group">
              <textarea id="newsBody" name="textarea-input" rows="9" class="form-control" placeholder="Content.." v-model="formData.body"></textarea>
            </div>
            <div class="form-group">
              <label for="weblink">Web Link</label>
              <input type="text" class="form-control" id="weblink" placeholder="Enter web link" v-model="formData.link">
            </div>
          </form>
    </div><!--/.col-->
  </b-modal>
  </div>
</template>

<script>
import alert from 'bootstrap-vue'

export default {
  name: 'Login',
  components: {alert},
  data () {
    return {
      msg: 'Coming Soon',
      loggingin: false,
      user: '',
      password: '',
      failedLogin: false,
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        body: '',
        link: '',
        startDate: '',
        endDate: ''
    },
    myModal: false
}},
  methods: {
    doLogin () {
      console.log(process.env.VUE_APP_API_BASE)
      this.loggingin = true;
      this.failedLogin = false;
      var config = {headers: ''};
      this.axios.post(process.env.VUE_APP_API_BASE + 'auth/token', {userName: this.user, password: this.password}, config).then(response => {
        return response
      })
      .then(res => {
        if (res.status === 200)
        {
          if (res.data.token === null)
          {
            this.failedLogin = true;
          }else
          {
            this.$localStorage.set('token', res.data.token);
            this.$localStorage.set('tokenExpiration', res.data.expiration);
            this.$localStorage.set('userFullName', res.data.userFullName);
            this.$localStorage.set('navleft',JSON.stringify(res.data.navleft));
            this.$localStorage.set('navleftOffline',JSON.stringify(res.data.navleftOffline));
            this.$store.state.userFullName = res.data.userFullName;
            console.log(this.$localStorage.get('token'))
            this.$router.replace('/MyMountain');
          }
        }else {
          this.failedLogin = true;
          this.loggingin = false;
        }
      })
      .catch(error => {
        this.failedLogin = true;
        this.loggingin = false;
      });
    }
  }
}
</script>

<style scope>

.error-container {
  position: fixed;
  top: 5px;
  left:2%;
  width: 96%;
}
</style>
